// Deployed hosts are `<subdomain>.brian-frontend.<…>`. The `/auth/login` body value is primary;
// brian's Host fallback is modules/clinic/subdomain.extract_subdomain.

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);
const IPV4 = /^\d{1,3}(?:\.\d{1,3}){3}$/;

/** Local and tailnet hosts identify a computer, not a clinic. Ask for the clinic. */
export const deriveSubdomainFromLocation = (
  hostname: string = window.location.hostname,
): string | null => {
  const host = hostname.trim().toLowerCase().replace(/\.$/, "");
  if (
    !host ||
    LOCAL_HOSTS.has(host) ||
    host.endsWith(".localhost") ||
    host.endsWith(".ts.net") ||
    IPV4.test(host)
  ) {
    return null;
  }
  const labels = host.split(".");
  if (labels.length < 3 || !labels[0]) return null;
  return labels[0];
};
